// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3yK_o","colCheckbox":"styles_colCheckbox__30ljh"};